<template>
  <v-app id="inspire">
    <!-- 
      Navegação lateral que permite ao usuário acessar diferentes páginas do aplicativo.
      O estado do drawer é controlado pela variável "drawer".
    -->
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <div class="pesquisarPageContainer">
          <!-- 
            Campo de texto para pesquisar páginas.
            A busca é realizada sempre que o valor é alterado.
          -->
          <v-text-field
            class="auto_complete_page"
            v-model="rotaPesquisada"
            @input="pesquisarRotas"
            append-icon="search"
            placeholder="Pesquisar Página"
            rounded
          ></v-text-field>
        </div>
        <v-list>
          <!-- 
            Renderiza uma lista de rotas filtradas com base na pesquisa do usuário.
            Cada item da lista redireciona o usuário para a rota correspondente.
          -->
          <v-list-item v-for="rota in rotasFiltradas" :key="rota.id" @click="redirecionarRota(rota)">
            <v-list-item-action>
              <v-icon>{{ rota.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ rota.descricao }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <!-- 
      Barra de aplicativo que contém o título, informações do usuário e o menu de perfil.
      A cor de fundo e o estilo são definidos para se ajustarem ao design do aplicativo.
    -->
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#006699" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
          <v-icon>menu</v-icon>
        </v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Eltsys Faturação</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span style="font-size:22px;">{{ empresa }} - {{ descricaoAnolectivo }}</span>
      <v-spacer></v-spacer>
      <v-divider style="margin-right:5px;font-weight:bold;" dark vertical></v-divider>
      <span>{{ username }}</span>
      <div class="text-center" width="800px">
        <!-- 
          Menu suspenso que exibe informações do usuário e opções como "Meu Perfil" e "Terminar Sessão".
        -->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="#27e62a" icon v-on="on">
              <v-icon>account_circle</v-icon>
            </v-btn>
          </template>
          <v-card width="300">
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon style="font-size:50px;">account_circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-weight:bold;">{{ loggedUserName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
                  <v-list-item-subtitle style="font-weight:bold">{{ descricao_role }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <!-- 
                Item de menu que redireciona para a página de perfil do usuário.
              -->
              <v-list-item @click="$router.push('perfil')">
                <v-list-item-action>
                  <v-icon>person</v-icon>
                </v-list-item-action>
                <v-list-item-title>Meu Perfil</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <!-- 
                Item de menu que chama a função "Call_Sair" para terminar a sessão do usuário.
              -->
              <v-list-item @click="Call_Sair()">
                <v-list-item-action>
                  <v-icon>logout</v-icon>
                </v-list-item-action>
                <v-list-item-title>Terminar Sessão</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- 
      Conteúdo principal do aplicativo, com um fundo personalizado.
      O breadcrumbs são exibidos se houver páginas disponíveis.
    -->
    <v-content class="circular" height="300" :style="{backgroundImage:'url(/img/logo.jpg)'}">
      <div v-if="paginas.length">
        <v-breadcrumbs :items="paginas" style="background-color: #fff;" divider="/"></v-breadcrumbs>
      </div>
      <!-- 
        Botão que permite ao usuário voltar para a página anterior, 
        exibido apenas se houver mais de uma página no histórico.
      -->
      <v-btn v-if="paginas.length > 1" class="botao_de_voltar" @click="voltar()" color="blue" fab small>
        <v-icon small color="white">arrow_back</v-icon>
      </v-btn>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Swal from 'sweetalert2';
import axios from './plugins/axios';
import { getState } from './state';
var ls = require('local-storage');

export default {
  data: () => ({
    rotasArray: [],
    rotasUser: [],
    rotasPadrao: [],
    rotasFiltradas: [],
    rotaPesquisada: '',
    empresa: '',
    email: '',
    username: '',
    drawer: null,
  }),

  computed: {
    /**
     * @returns {Array} - Array de páginas, obtido do estado global.
     */
    paginas() {
      return getState().paginas || [];
    },
    
    /**
     * @returns {string} - Descrição do ano letivo, recuperada do localStorage.
     */
    descricaoAnolectivo() {
      return ls.get('descricaoAnolectivo');
    },
    
    /**
     * @returns {string} - Descrição do papel do usuário, recuperada do localStorage.
     */
    descricao_role() {
      return ls.get('descricao_role');
    },
    
    /**
     * @returns {string} - Nome do usuário logado, recuperado do localStorage.
     */
    loggedUserName() {
      return ls.get('nomeUsuario');
    },
    
    /**
     * @returns {string} - Email do usuário logado, recuperado do localStorage.
     */
    loggedEmail() {
      return ls.get('username');
    },
    
    /**
     * @returns {string} - Nome da empresa, recuperada do localStorage.
     */
    empresa() {
      return ls.get('empresa');
    },
  },

  methods: {
    /**
     * Redireciona o usuário para a página anterior no histórico de navegação.
     */
    voltar() {
      this.$router.push(this.paginas[this.paginas.length - 2].to);
    },

    /**
     * Carrega as rotas disponíveis para o usuário com base no nível de acesso.
     * - As rotas são obtidas do servidor e filtradas conforme o nível do usuário.
     * @async
     */
    async carregarRotas() {
      try {        
        const role = ls.get('nivel_user');
        this.rotasArray = await axios.get('/pesquisarRotas').then((res) => res.data);

        this.rotasUser = this.rotasArray.filter(objeto => {
          const niveis = objeto.niveis.split(',');
          return niveis.includes(`${role}`);
        });

        this.rotasPadrao = this.rotasUser.filter(rotas => rotas.menu === 1);
        this.rotasFiltradas = this.rotasPadrao;

        ls.set('rotas', JSON.stringify(this.rotasUser));
      } catch (error) {        
        // Exibe uma mensagem de erro se houver falha ao carregar as rotas.
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos menus!', 'error');
      }
    },

    async carregarFuncoesRole() {
      // Obtém o nível do usuário armazenado no localStorage
      const role = ls.get('nivel_user');
      // Verifica se o nível do usuário está disponível
      if (role) {
        try {
          // Tenta obter as funções salvas para o nível do usuário
          const funcoesSaved = JSON.parse(ls.get('FuncoesPorRole'));
          
          // Se não houver funções salvas ou a lista estiver vazia, carrega as funções do servidor
          if (!funcoesSaved || !funcoesSaved.length) {
            // Faz uma requisição para o servidor para obter as funções correspondentes ao nível do usuário
            let response = await axios.get('/carregarFuncoesRole').then((res) => res.data);
            
            // Filtra as funções recebidas, mantendo apenas aquelas que correspondem ao nível do usuário
            let funcoes = response.filter(objeto => {
              // Divide a string de níveis em um array e verifica se o nível do usuário está incluído
              const niveis = objeto.niveis.split(',');
              return niveis.includes(`${role}`);
            });
            
            // Armazena as funções filtradas no localStorage para uso futuro
            ls.set('FuncoesPorRole', JSON.stringify(funcoes));
          }
        } catch (error) {
          Swal.fire('Erro', 'Erro ao validar funções por role!', 'error');
        }
      } else {
        Swal.fire('Erro', 'Nivél do usuário não encontrado!', 'error');
      }
    },


    /**
     * Redireciona o usuário para a rota selecionada.
     * - A rota é passada como argumento.
     * @param {Object} rota - O objeto rota que foi clicado.
     */
    redirecionarRota(rota) {
      this.$router.push(rota.url);
      this.rotaPesquisada = '';
      this.rotasFiltradas = this.rotasPadrao;
    },

    /**
     * Filtra as rotas disponíveis com base na pesquisa do usuário.
     * - Se não houver resultados, a pesquisa é registrada no servidor.
     * @async
     */
    async pesquisarRotas() {
      try {
        if (this.rotaPesquisada) {
          this.rotasFiltradas = this.rotasArray.filter(rota => rota.descricao.toLowerCase().includes(this.rotaPesquisada.toLowerCase()));

          if (!this.rotasFiltradas.length) {
            let params = {
              descricao: this.rotaPesquisada,
              nivel: ls.get('nivel_user') ? ls.get('nivel_user') : 0,
              user: ls.get('nomeUsuario'),
            };
            await axios.post('/salvarPesquisa', params);
          }
        } else {
          this.rotasFiltradas = this.rotasPadrao;
        }
      } catch (error) {
        // Exibe uma mensagem de erro se houver falha ao procurar a página.
        Swal.fire('Error', 'Ocorreu um erro ao procurar a página!', 'error');
      }
    },

    /**
     * Termina a sessão do usuário, removendo dados do localStorage e redirecionando para a página inicial.
     */
    async Call_Sair() {
      ls.remove('token');
      ls.clear();
      this.$router.push('/');
    },
  },

  /**
   * Hook de ciclo de vida do Vue que carrega rotas e dados do usuário ao criar o componente.
   */
  created() {
    this.carregarRotas();
    this.carregarFuncoesRole();
    this.empresa = ls.get('empresa');
    this.email = ls.get('email');
  }
}
</script>

<style scoped>
.auto_complete_page {
  align-items: center;
  border: 1px solid #f3eee3;
  background: #f3eee3;
  padding-top: 20px;
  height: 35px;
  border-radius: 10px;
  width: 98%;
  margin: 0 auto 5px;
  text-align: center;
  color: #fff;
}

.botao_de_voltar {
  position: absolute;
  right: 5px;
  top: 10px;
  z-index: 100;
}
</style>
